// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"230":"bc446a0b","637":"2f0f5d98","678":"9e3a8b12"}[chunkId] + ".chunk.css";
};